module.exports = __webpack_public_path__ + "static/Githzerai-7a6afbde8a5a328343ef545fcd43aa9e.jpg";